/**
 * The number of lines that the version text takes in the 2026 splash design.
 *
 * Blank lines at the end take no space. The 2025 design (Splash, Splash2x)
 * puts the logo directly below the text, so its default texts end the version
 * with a blank line ("2026.1\n") to keep the logo in position. All designs of
 * the splash slot share the texts, thus this design gets these texts too.
 */
export function versionLineCount(text: string): number {
  const trimmed = text.replace(/\s+$/u, "");
  return trimmed === "" ? 1 : trimmed.split("\n").length;
}
